/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvoiceTotalsDto { 
    /**
     * Total organizer earning in cents
     */
    totalOrganizerEarningCents: number;
    /**
     * Total commission in cents (gross): sum of eventRevenue * commissionPercentage / 100 per line
     */
    totalCommissionCents: number;
}

